import { type ToastMessageOptions } from 'primevue';

export enum ToastMessageType {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  SUCCESS = 'success'
}

const currentToastId = ref<number>(0);
const closeHooks = ref<Record<number, () => void>>({});

export const onToastClosed = (e: ToastMessageOptions): void => {
  const toast = e as {
    message: ToastMessageOptions & { id: number };
  };

  if (toast.message.id && closeHooks.value[toast.message.id]) {
    closeHooks.value[toast.message.id]();
  }
};

export function useShowToast() {
  const toast = useToast();

  const showToast = (
    message: string,
    options?: ToastMessageOptions & { onClose?: () => void }
  ) => {
    if (
      options &&
      'onClose' in options &&
      typeof options.onClose === 'function'
    ) {
      closeHooks.value[currentToastId.value] = options.onClose;
      delete options.onClose;
    }

    toast.add({
      summary: message,
      severity: 'success',
      ...options
    });
    currentToastId.value = currentToastId.value + 1;
  };

  return {
    showToast
  };
}
